export default __webpack_public_path__ + "static/media/Delivery_Tracking_Disable.ff48cc77.svg";